function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M11.077 13.314c-1.275 0-2.308 1.088-2.308 2.429V35.17c0 1.342 1.033 2.429 2.308 2.429h25.846c1.275 0 2.308-1.087 2.308-2.429V15.743c0-1.341-1.033-2.429-2.308-2.429H11.077zm0-2.914h25.846c2.804 0 5.077 2.392 5.077 5.343V35.17c0 2.951-2.273 5.343-5.077 5.343H11.077C8.273 40.514 6 38.122 6 35.171V15.743c0-2.95 2.273-5.343 5.077-5.343zM6.5 19.629h35v2.914h-35v-2.914zM16 7a1.5 1.5 0 0 1 1.5 1.5v6.714a1.5 1.5 0 0 1-3 0V8.5A1.5 1.5 0 0 1 16 7zm15 0a1.5 1.5 0 0 1 1.5 1.5v6.714a1.5 1.5 0 0 1-3 0V8.5A1.5 1.5 0 0 1 31 7z"
});

var SvgEta = function SvgEta(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgEta;


//////////////////
// WEBPACK FOOTER
// ./src/icons/eta.svg
// module id = 272
// module chunks = 0 1